// eslint-disable-next-line
// @ts-nocheck
import React from "react";

export const AudioVisualizer = React.lazy(async () => {
  const { AudioVisualizer } = await import("react-audio-visualize");
  return { default: AudioVisualizer };
});
